import { render, staticRenderFns } from "./HeaderRelease.vue?vue&type=template&id=387406ac"
import script from "./HeaderRelease.vue?vue&type=script&lang=ts"
export * from "./HeaderRelease.vue?vue&type=script&lang=ts"
import style0 from "./HeaderRelease.vue?vue&type=style&index=0&id=387406ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports